import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-258">
      <div className="max-w-3xl mx-auto text-center" data-id="element-259">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-260">
          ¿CUÁNTOS FINES DE SEMANA MÁS VAS A PERDER?
        </h2>

        <p className="text-gray-300 text-lg sm:text-xl mb-4 leading-relaxed" data-id="element-261">
          Eres docente de Italiano. Amas el idioma. Pero nadie te dijo que ibas
          a pasar los domingos buscando actividades que no encajan con tus
          estudiantes, armando evaluaciones a última hora y llegando al lunes
          con material que "más o menos sirve".
        </p>

        <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-10" data-id="element-262">
          No es falta de vocación. Es falta de un sistema.
        </p>

        <div className="space-y-4 text-left mb-12" data-id="element-263">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-264">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-265">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-266">
              Buscar actividades que nunca quedan bien para tus estudiantes
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-267">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-268">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-269">
              Armar planificaciones para dirección la noche anterior
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-270">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-271">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-272">
              Reutilizar siempre las mismas evaluaciones por falta de banco
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-273">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-274">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-275">
              Enseñar Congiuntivo, Periodo Ipotetico, Pronomi Combinati sin
              sistema visual
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-276">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-277">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-278">
              Grupos con distintos niveles sin material diferenciado — enseñas
              al promedio y pierdes a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-279">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-280">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-281">
              Agotado el viernes, reiniciando el mismo ciclo el domingo
            </p>
          </div>
        </div>

        <p className="text-[#00C853] text-2xl sm:text-3xl font-black mb-8 italic" data-id="element-282">
          ¿Y si este fuera el último fin de semana que pasas así?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00C853] to-transparent w-full" data-id="element-283" />
      </div>
    </section>;
}